import React from 'react';
import { archivedIcon } from '@/constants/images';
import ToastWrapper from './ToastWrapper';
import ToastMessage from './ToastMessage';

const ArchivedToast = ({ items, isArchival }) => (
  <ToastWrapper
    className="aridhia-archived-toast"
    icon={archivedIcon(isArchival)}
    color={isArchival ? 'red' : 'green'}
  >
    <ToastMessage
      items={items}
      multiple={isArchival ? 'toast.archives' : 'toast.restores'}
      single={isArchival ? 'toast.archived' : 'toast.restored'}
    />
  </ToastWrapper>
);

export default ArchivedToast;
